import { useServices } from 'ha/services';
import { newReduxTracker } from './reduxTracker';

export function useReduxTracker(): ReturnType<typeof newReduxTracker> {
  const { cookie } = useServices();
  return newReduxTracker(cookie);
}
